module.exports = __webpack_public_path__ + "img/0.02e5f4b6.jpg";